import React from 'react';
import { Link } from '@reach/router';
import Testimony from '../components/carouseltestimony';
import Footer from '../components/footer';


export default () => (
<div className='wraperitem'>
  <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/testimony.jpg'})`}}>
    <div className='mainbreadcumb'>
      <div className='container-fluid'>
        <div className='row m-10-hor'>
          <div className='col-md-6'>
            <h1>About us</h1>
          </div>
          <div className='col-md-6'>
            <div className='list'>
              <Link className='link' to="/home">Home</Link>
              <span className='dash'>/</span>
              <span>About</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className='container-fluid black_more'>
        <div className='row m-10-hor'>

        <div className='col-md-5'>
            <div className='heading'>
              Perfection<span className='br'></span> concept<span className='br'></span> Design
            </div>
          </div>

          <div className='col-md-7'>
            <div className='content'>
              Witaly Group is a premier design studio specialising in luxury interiors,
              architecture, and hospitality spaces. With a passion for craftsmanship and
              an eye for detail, we transform ideas into environments that inspire,
              comfort, and endure.
            </div>
            <div className='content'>
              From bespoke private residences to world-class resorts and restaurants,
              our multidisciplinary team brings together creativity, technical expertise,
              and a deep understanding of our clients' vision to deliver spaces that
              exceed expectations at every turn.
            </div>
          </div>

        </div>
  </section>

  <section className='container-fluid p-0'>
        <div className='row'>

          <div className="col-md-6 px-0">
            <img src="./img/blog.jpg" className="imgslickz" alt="#"/>
          </div>

          <div className="col-md-6 centered p-md-5 pt-5">
            <div className="p-md-5">
              <div className="subheading">Our Philosophy</div>
              <div className="heading">
                Design That Tells Your Story
              </div>
              <p className="mt-3">
                We believe great design goes beyond aesthetics. Every project begins
                with listening — understanding how you live, what you value, and the
                atmosphere you want to create. The result is a space that feels
                uniquely and authentically yours.
              </p>
              <Link className='btn' to="/works">
                <span className="shine"></span>
                <span>View Our Work</span>
              </Link>
            </div>
          </div>

          <div className="col-md-6 centered p-md-5 pt-5 pb-5">
            <div className="p-md-5">
              <div className="subheading">Our Approach</div>
              <div className="heading">
                Precision in Every Detail
              </div>
              <p className="mt-3">
                From the first sketch to the final finish, we manage every stage
                of the design and build process with meticulous care. Our team
                collaborates closely with contractors, suppliers, and clients
                to ensure seamless delivery — on time and to the highest standard.
              </p>
              <Link className='btn' to="/contact">
                <span className="shine"></span>
                <span>Get in Touch</span>
              </Link>
            </div>
          </div>

          <div className="col-md-6 px-0">
            <img src="./img/blog1.jpg" className="imgslickz" alt="#"/>
          </div>

        </div>
  </section>

  <Testimony />
  <Footer />
</div>

);
